import React, { Component } from 'react';
import PipelineProgress from "../../Progress/ExtraLargePipeline";
import moment from 'moment-timezone'
import {format}  from 'date-fns';
import { sv } from "date-fns/locale";
import { injectIntl } from 'react-intl';

class Pipeline extends Component {
    render() {
        const placeholder = this.props.intl.formatMessage({ id: 'Prospectus' });
        return (
            <div className="text-center" style={{ color: 'white' }}>
                <div>
                    <h2 style={{ paddingTop: '12px', marginBottom: '1rem', fontWeight: '500' }}>
                    {`${placeholder} ${format(new Date(), 'MMMM', { locale: sv })}`}
                    </h2>
                </div>
                <div style={{marginTop: this.props.isFrom === 1? '2rem' : '-0.5rem'}}>
                    <PipelineProgress isFrom={this.props.isFrom} Afid={this.props.Afid} Flags={this.props.Flags}
                     Kontor={this.props.Kontor}
                    />
                </div>
            </div>
        )
    }
}
export default injectIntl(Pipeline);